import type {
  SkeletonSlots as SkeletonBaseSlots,
  SkeletonBaseProps,
  SkeletonBaseState,
  SkeletonContextValues as SkeletonContextValuesBase,
} from '@fluentui/react-skeleton';

/**
 * Skeleton component slots
 */
export type SkeletonSlots = SkeletonBaseSlots;

/**
 * Skeleton component props
 */
export type SkeletonProps = SkeletonBaseProps;

/**
 * Skeleton component state
 */
export type SkeletonState = SkeletonBaseState;

/**
 * Skeleton component context values
 */
export type SkeletonContextValues = SkeletonContextValuesBase;
